import { IMG } from "../data/content";
import { Eyebrow, Reveal } from "./Reveal";

const CARDS = [
  { img: IMG.neon, title: "The neon wall", tag: "Photo Op", span: "md:col-span-7", ratio: "aspect-[4/3]" },
  { img: IMG.table, title: "The table everyone wishes they reserved", tag: "Squad Goals", span: "md:col-span-5", ratio: "aspect-[4/3] md:aspect-auto" },
  { img: IMG.bar, title: "The emerald bar", tag: "Artisan Brews", span: "md:col-span-4", ratio: "aspect-[4/3]" },
  { img: IMG.velvet, title: "Velvet corners, street views", tag: "Cozy Nook", span: "md:col-span-4", ratio: "aspect-[4/3]" },
  { img: IMG.flatlay, title: "A table curated for every craving", tag: "Pizza Party", span: "md:col-span-4", ratio: "aspect-[4/3]" },
  { img: IMG.bowl, title: "Busy falling in love with this bowl", tag: "Soul Food", span: "md:col-span-6", ratio: "aspect-[4/3] md:aspect-auto" },
  { img: IMG.slicePull, title: "Accepting apologies in pizza slices", tag: "Cheese Pull", span: "md:col-span-6", ratio: "aspect-[4/3] md:aspect-auto" },
];

export default function Vibe() {
  return (
    <section id="vibe" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="vibe-section">
      <Reveal>
        <Eyebrow>Step inside</Eyebrow>
        <h2 className="mt-4 max-w-2xl font-serif text-2xl tracking-tight text-cream sm:text-3xl lg:text-4xl">
          Emerald, velvet &amp; neon — <em className="italic text-neon">some places you don't scroll past.</em>
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-12">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.08} className={`${c.span} h-full`}>
            <figure
              data-testid={`vibe-card-${i}`}
              className="group relative h-full w-full overflow-hidden rounded-2xl border border-cream/5"
            >
              <img
                src={c.img}
                alt={`${c.title} at Brewing Bistro, Baner`}
                loading="lazy"
                className={`w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06] ${c.ratio} md:h-full`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-espresso/85 via-transparent to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
              <figcaption className="absolute bottom-0 left-0 right-0 flex items-end justify-between p-5">
                <span className="font-serif text-lg text-cream">{c.title}</span>
                <span className="rounded-full border border-neon/30 bg-espresso/60 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-neon backdrop-blur-sm">
                  {c.tag}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
